(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        /* Match footer.css (769px), not theme.mediaQueries.md (1024px for the header). */
        this.largeScreenMq = window.matchMedia('(min-width: 769px)');
        this.reset();
        this.largeScreenMq.addEventListener('change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = this.largeScreenMq.matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  (function linkifyFooterContacts() {
    const roots = document.querySelectorAll('.footer .footer-block__text');
    if (!roots.length) return;

    const emailRe = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
    const phoneRe = /(?:\+|00)?(?:\d[\s().-]*){9,}\d/g;

    function toWhatsApp(raw) {
      let digits = String(raw).replace(/[^\d+]/g, '');
      if (digits.indexOf('00') === 0) digits = '+' + digits.slice(2);
      if (digits.charAt(0) === '0') digits = '44' + digits.slice(1);
      digits = digits.replace(/\D/g, '');
      if (digits.length < 10 || digits.length > 15) return '';
      return 'https://wa.me/' + digits;
    }

    function overlaps(matches, start, end) {
      return matches.some(function (item) {
        return start < item.end && end > item.start;
      });
    }

    roots.forEach(function (root) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          if (node.parentElement && node.parentElement.closest('a, script, style, noscript')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach(function (node) {
        const text = node.nodeValue;
        const matches = [];
        emailRe.lastIndex = 0;
        phoneRe.lastIndex = 0;
        let match;
        while ((match = emailRe.exec(text))) {
          matches.push({ type: 'email', start: match.index, end: match.index + match[0].length, value: match[0] });
        }
        while ((match = phoneRe.exec(text))) {
          if (!overlaps(matches, match.index, match.index + match[0].length)) {
            matches.push({ type: 'phone', start: match.index, end: match.index + match[0].length, value: match[0] });
          }
        }
        if (!matches.length) return;
        matches.sort(function (a, b) { return a.start - b.start; });

        const frag = document.createDocumentFragment();
        let last = 0;
        matches.forEach(function (item) {
          if (item.start > last) frag.appendChild(document.createTextNode(text.slice(last, item.start)));
          if (item.type === 'phone') {
            const href = toWhatsApp(item.value);
            if (!href) {
              frag.appendChild(document.createTextNode(item.value));
              last = item.end;
              return;
            }
            const a = document.createElement('a');
            a.href = href;
            a.target = '_blank';
            a.rel = 'noopener';
            a.textContent = item.value;
            frag.appendChild(a);
          } else {
            const a = document.createElement('a');
            a.href = 'mailto:' + item.value;
            a.textContent = item.value;
            frag.appendChild(a);
          }
          last = item.end;
        });
        if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
        node.parentNode.replaceChild(frag, node);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
